<template>
  <v-row justify="center">
    <v-col cols="6">
      <!-- user -->
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Cuenta de usuario</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item>
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.user.first_name.$model" :error="$v.user.first_name.$error" background-color="white" outlined hide-details required single-line dense placeholder="Escribe un nombre de usuario" maxlength="30" data-action="auto-focus" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Apellido</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.user.last_name.$model" :error="$v.user.last_name.$error" background-color="white" outlined hide-details required single-line dense  placeholder="Escribe un nombre" maxlength="30" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="patchUser" :loading="patchLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
      <!-- end user -->

      <!-- credentials -->
      <v-card class="my-5">
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Seguridad de la cuenta</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 background">
          <v-list class="v-list-form-extended py-6 transparent">
            <v-list-item>
              <v-list-item-title>Contraseña</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="4">
                  <v-btn @click.stop="modalPatchPassword=true" block outlined>Cambiar contraseña</v-btn>
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Token</v-list-item-title>
              <v-list-item-subtitle class="py-1 pl-5">
                 <v-col cols="12">
                   <v-text-field class="icon-field" v-model="tokensList" @click:append="showToken = !showToken" readonly :append-icon="showToken ? 'mdi-eye' : 'mdi-eye-off'" :type="showToken ? 'value' : 'password'" background-color="white" outlined hide-details required single-line dense maxlength="56" data-action="auto-focus" />
                </v-col>
              </v-list-item-subtitle>
              <v-list-item-action class="py-1 mr-4">
                <v-col>
                  <v-btn @click.stop="patchTokens" :loading="patchLoaderToken" block outlined>Actualizar</v-btn>
                </v-col>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
      <!-- end credentials -->

      <!-- organizations -->
      <v-card class="my-5">
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Organizaciones</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row class="mx-0">
            <v-col class="py-0" cols="12">
              <v-card class="my-4" v-for="d in accountsList" :key="d.id" :ripple="false">
                <v-card-text class="pa-3">
                  <v-list class="transparent">
                    <v-list-item class="my-1">
                      <v-list-item-title class="body-1 text--secondary font-weight-medium">{{d.name}}</v-list-item-title>
                      <v-list-item-subtitle class="text-right">
                        <v-tooltip right transition="scale-transition">
                          <template v-slot:activator="{on}">
                            <v-btn text v-on="on">
                              <code @click="toClipboard(d.id)" class="pa-1 font-weight-regular text--secondary background">
                                <v-icon x-small top>mdi-content-copy</v-icon>
                                <span> {{d.id}}</span>
                              </code>
                            </v-btn>
                          </template>
                          <span class="caption">Copiar identificador</span>
                        </v-tooltip>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <!-- end organizations -->
    </v-col>

    <!-- dialog update password -->
    <v-dialog v-model="modalPatchPassword" width="500" persistent no-click-animation>
      <v-card>
        <v-toolbar flat height="55">
          <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Cambiar contraseña</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="modalPatchPassword=false" icon small retain-focus-on-click><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item>
              <v-list-item-title>Contraseña actual</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-text-field class="icon-field" v-model.trim="$v.password.old_password.$model" :error="$v.password.old_password.$error" @click:append="show = !show" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? '$v.password.old_password.$model' : 'password'" background-color="white" outlined hide-details required single-line dense maxlength="56" data-action="auto-focus" placeholder="Escribe tu contraseña actual" />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Nueva contraseña</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-text-field class="icon-field" v-model.trim="$v.password.new_password1.$model" :error="$v.password.new_password1.$error" @click:append="show1 = !show1" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'user.password1' : 'password'" background-color="white" outlined hide-details required single-line  dense maxlength="56" data-action="auto-focus" placeholder="Escribe una nueva contraseña segura" />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Confirmar contraseña</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-text-field class="icon-field" v-model.trim="$v.password.new_password2.$model" :error="$v.password.new_password2.$error" @click:append="show2 = !show2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'user.password2' : 'password'" background-color="white" outlined hide-details required single-line dense maxlength="56" placeholder="Escribe otra vez la nueva contraseña" />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="modalPatchPassword=false" outlined>Cancelar</v-btn>
          <v-btn @click="patchPassword" :loading="patchLoader" color="primary">Cambiar contraseña</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog update password -->
  </v-row>
</template>
<script>
import { required, sameAs, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  data () {
    return {
      token: [],
      user: {
        first_name: '',
        last_name: ''
      },
      password: {
        new_password1: '',
        new_password2: '',
        old_password: ''
      },
      patchLoader: false,
      patchLoaderToken: false,
      modalPatchPassword: false,
      show: false,
      show1: false,
      show2: false,
      showToken: false
    }
  },
  computed: mapState({
    accountsList: state => state.accounts.accountsList,
    tokensList: state => (((state.accounts.tokensList || [])[0] || {}).key || '')
  }),
  created () {
    this.$store.dispatch('auth/GET_USER')
    .then((response) => {
      this.user = response.data
    })
    this.$store.dispatch('accounts/LIST', {
      resource: 'accounts'
    })
    this.$store.dispatch('accounts/LIST', {
      resource: 'tokens'
    })
  },
  methods: {
    patchUser () {
      this.$v.user.$touch()
      if (this.$v.user.$invalid) {
        return false
      }
      this.patchLoader = true
      this.$store.dispatch('auth/PATCH_USER', {
        first_name: this.user.first_name,
        last_name: this.user.last_name
      })
      .then((response) => {
        this.$dialog.message.info('La información de usuario se ha actualizado')
      })
      .finally(() => {
        this.patchLoader = false
      })
    },
    patchPassword () {
      this.$v.password.$touch()
      if (this.$v.password.$invalid) {
        return false
      }
      this.patchLoader = true
      this.$store.dispatch('auth/POST_USER_PASSWORD', {
        new_password1: this.password.new_password1,
        new_password2: this.password.new_password2,
        old_password: this.password.old_password
      })
      .then((response) => {
        this.modalPatchPassword = false
        this.patchLoader = false
        this.password = {
          new_password1: '',
          new_password2: '',
          old_password: ''
        }
        this.$v.password.$reset()
        this.$dialog.message.info(response.data.detail)
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
      .finally(() => {
        this.patchLoader = false
      })
    },
    patchTokens () {
      this.$dialog.warning({
        title: 'Actualizar token',
        text: `
          <span class="d-block">Al confirmar, el token existente se eliminará y se creará uno nuevo.</span>
          <span class="d-block my-4 font-weight-medium">Recuerda actualizar el token usado en tus integraciones.</span>
        `,
        actions: [
          {
            text: 'Continuar',
            color: 'primary',
            handle: () => {
              this.patchLoaderToken = true
              this.$store.dispatch('accounts/CREATE', {
                resource: 'tokens',
                payload: {}
              })
              .then(() => {
                this.$store.dispatch('accounts/LIST', {
                  resource: 'tokens'
                })
                this.$dialog.message.info('Tu token ha actualizado')
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
              .finally(() => {
                this.patchLoaderToken = false
              })
            }
          }
        ]
      })
    }
  },
  validations: {
    user: {
      first_name: {
        maxLength: maxLength(30)
      },
      last_name: {
        maxLength: maxLength(30)
      }
    },
    password: {
      new_password1: {
        required,
        minLength: minLength(8)
      },
      new_password2: {
        sameAsPassword: sameAs('new_password1')
      },
      old_password: {
        required
      }
    }
  }
}
</script>